/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_ax_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I lock in drivers I already own?`)
};

const es_f1_ax_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo bloquear pilotos que ya tengo?`)
};

const de_f1_ax_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich Fahrer sperren, die ich bereits im Team habe?`)
};

const nl_f1_ax_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik coureurs vergrendelen die ik al bezit?`)
};

const fr_f1_ax_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je verrouiller des pilotes que je possède déjà ?`)
};

const it_f1_ax_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso bloccare i piloti che ho già?`)
};

const pt_br2_f1_ax_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso fixar pilotos que já tenho na minha equipe?`)
};

const pt_f1_ax_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso bloquear pilotos que já tenho?`)
};

const ja_f1_ax_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すでに保有しているドライバーをロックできますか？`)
};

const zh_f1_ax_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我可以锁定已经拥有的车手吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_ax_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_ax_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_ax_faq2_q", locale)
	if (locale === "en") return en_f1_ax_faq2_q(inputs)
	if (locale === "es") return es_f1_ax_faq2_q(inputs)
	if (locale === "de") return de_f1_ax_faq2_q(inputs)
	if (locale === "nl") return nl_f1_ax_faq2_q(inputs)
	if (locale === "fr") return fr_f1_ax_faq2_q(inputs)
	if (locale === "it") return it_f1_ax_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_f1_ax_faq2_q(inputs)
	if (locale === "pt") return pt_f1_ax_faq2_q(inputs)
	if (locale === "ja") return ja_f1_ax_faq2_q(inputs)
	return zh_f1_ax_faq2_q(inputs)
};